"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
exports.__esModule = true;
var React = require("react");
var ReactDOM = require("react-dom");
var react_1 = require("react");
var styled_components_1 = require("styled-components");
var useFetchSituationOptions_1 = require("../../hooks/useFetchSituationOptions");
var PresentSearch_1 = require("../PresentSearch");
var SituationSelectDescriptor_1 = require("./SituationSelectModal/SituationSelectDescriptor");
var SituationSelectFooter_1 = require("./SituationSelectModal/SituationSelectFooter");
var SituationSelectHeader_1 = require("./SituationSelectModal/SituationSelectHeader");
var SituationSelectNavigator_1 = require("./SituationSelectModal/SituationSelectNavigator");
var SituationSelectOptions_1 = require("./SituationSelectModal/SituationSelectOptions");
var SituationSelectOptionsGroups_1 = require("./SituationSelectModal/SituationSelectOptionsGroups");
var LogEvent_1 = require("../../../../../external_tracker/amplitude/LogEvent");
var titleOf = {
    presentee: "贈る相手を選択",
    age: "年代を選択",
    occasion: "目的を選択"
};
// モーダルの状態。 Closed 以外では各選択肢を表示している
var ModalState;
(function (ModalState) {
    ModalState[ModalState["Closed"] = 0] = "Closed";
    ModalState[ModalState["Presentee"] = 1] = "Presentee";
    ModalState[ModalState["Age"] = 2] = "Age";
    ModalState[ModalState["Occasion"] = 3] = "Occasion";
})(ModalState = exports.ModalState || (exports.ModalState = {}));
var toModalStateLabelForLog = function (state) {
    switch (state) {
        case ModalState.Presentee:
            return "Presentee";
        case ModalState.Age:
            return "Age";
        case ModalState.Occasion:
            return "Event";
        default:
            return "";
    }
};
// 選択モーダルコンポーネント
exports.SituationSelectModal = function (props) {
    var _a = react_1.useState(props.state === ModalState.Presentee
        ? PresentSearch_1.UnselectedPresentee
        : props.state === ModalState.Age
            ? PresentSearch_1.UnselectedAge
            : props.state === ModalState.Occasion
                ? PresentSearch_1.UnselectedOccasion
                : PresentSearch_1.UnselectedPresentee), selected = _a[0], setSelected = _a[1];
    var _b = react_1.useState(ModalState.Closed), prevState = _b[0], setPrevState = _b[1];
    var _c = react_1.useState(true), inTransition = _c[0], setInTransition = _c[1];
    // 自分以後の選択肢を選択している時のみ選択中の値を渡して fetch する
    var _d = useFetchSituationOptions_1.useFetchSituationOptions(props.state, props.state <= ModalState.Presentee ? "" : props.selectedPresentee.id, props.state <= ModalState.Age ? "" : props.selectedAge.id, props.state <= ModalState.Occasion ? "" : props.selectedOccasion.id), situationOptions = _d[0], success = _d[1], error = _d[2];
    // モーダルの開閉時はトランジション状態に
    react_1.useEffect(function () {
        if ((prevState === ModalState.Closed && props.state !== ModalState.Closed) ||
            (prevState !== ModalState.Closed && props.state === ModalState.Closed)) {
            setInTransition(true);
        }
        setPrevState(props.state);
    }, [props.state]);
    // データの更新が終わったらトランジション状態を非アクティブに
    react_1.useEffect(function () {
        if (props.state !== ModalState.Closed && success) {
            setInTransition(false);
        }
    }, [success]);
    var modalRoot = document.querySelector("#react-modal-root");
    if (modalRoot === null) {
        throw new Error("#react-modal-root に対応する DOM が見つかりませんでした");
    }
    // 閉じている
    if (props.state === ModalState.Closed) {
        return ReactDOM.createPortal(null, modalRoot);
    }
    // キャンセルでは選択状態を巻き戻してからモーダルを閉じる
    var cancel = function () {
        props.undoSelected();
        props.setModalState(ModalState.Closed);
        LogEvent_1.logEvent("Present Search Cancel at " + toModalStateLabelForLog(props.state));
    };
    // 選択状態に応じてよしななスキップ処理をして次へ
    var skip = function () {
        fixSelected();
        setInTransition(true);
        LogEvent_1.logEvent("Present Search Skip at " + toModalStateLabelForLog(props.state));
        switch (props.state) {
            case ModalState.Presentee:
                // 相手をスキップする場合は年代を飛ばす
                props.selectAge(PresentSearch_1.UnselectedAge);
                props.setModalState(ModalState.Occasion);
                break;
            case ModalState.Age:
                props.setModalState(ModalState.Occasion);
                break;
            case ModalState.Occasion:
                props.setModalState(ModalState.Closed);
                break;
            default:
                props.setModalState(ModalState.Presentee);
        }
    };
    // 次の画面へ遷移
    var next = function () {
        switch (props.state) {
            case ModalState.Presentee:
                props.setModalState(ModalState.Age);
                break;
            case ModalState.Age:
                props.setModalState(ModalState.Occasion);
                break;
            case ModalState.Occasion:
                props.setModalState(ModalState.Closed);
                break;
            default:
                props.setModalState(ModalState.Presentee);
        }
    };
    // 現在の選択状態を反映する
    var fixSelected = function () {
        select(selected);
    };
    // 渡された Option を選択結果として反映する
    var select = function (option) {
        switch (props.state) {
            case ModalState.Presentee:
                props.selectPresentee(option);
                break;
            case ModalState.Age:
                props.selectAge(option);
                break;
            case ModalState.Occasion:
                props.selectOccasion(option);
                break;
        }
    };
    var back = function () {
        switch (props.state) {
            case ModalState.Presentee:
                props.undoSelected();
                setInTransition(true);
                props.setModalState(ModalState.Closed);
                break;
            case ModalState.Age:
                setInTransition(true);
                props.setModalState(ModalState.Presentee);
                break;
            case ModalState.Occasion:
                setInTransition(true);
                props.setModalState(ModalState.Age);
                break;
        }
    };
    // 渡された物を反映して次に進む
    var onSelect = function (option) {
        LogEvent_1.logEvent("Present Search Select at " + toModalStateLabelForLog(props.state), { "Selected Option": option.name });
        select(option);
        setInTransition(true);
        next();
    };
    // ステートを移動
    var toPresenteeState = function () {
        setInTransition(true);
        props.setModalState(ModalState.Presentee);
    };
    var toAgeState = function () {
        setInTransition(true);
        props.setModalState(ModalState.Age);
    };
    var toOccasionState = function () {
        setInTransition(true);
        props.setModalState(ModalState.Occasion);
    };
    // 選択肢ロード中、若しくはロード失敗
    if (inTransition) {
        return ReactDOM.createPortal(React.createElement(Window, null,
            React.createElement(SituationSelectHeader_1.SituationSelectHeader, { title: props.state === ModalState.Presentee
                    ? titleOf.presentee
                    : props.state === ModalState.Age
                        ? titleOf.age
                        : props.state === ModalState.Occasion
                            ? titleOf.occasion
                            : titleOf.presentee, cancel: cancel }),
            React.createElement(SituationSelectNavigator_1.SituationSelectNavigator, { state: props.state, selectedPresentee: props.selectedPresentee, selectedAge: props.selectedAge, selectedOccasion: props.selectedOccasion, onClickPresentee: toPresenteeState, onClickAge: toAgeState, onClickOccasion: toOccasionState }),
            React.createElement(SituationSelectDescriptor_1.SituationSelectDescriptor, { state: props.state }),
            React.createElement(Options, { inTransition: true },
                React.createElement(OptionsContentLoading, null)),
            React.createElement(SituationSelectFooter_1.SituationSelectFooter, { selected: selected, back: props.state > ModalState.Presentee ? back : null, skip: skip })), modalRoot);
    }
    var optionElements = props.state === ModalState.Presentee ? (React.createElement(SituationSelectOptions_1.SituationSelectOptions, { options: situationOptions.presenteeOptions, selected: selected, onSelect: onSelect })) : props.state === ModalState.Age ? (React.createElement(SituationSelectOptions_1.SituationSelectOptions, { options: situationOptions.ageOptions, selected: selected, onSelect: onSelect })) : props.state === ModalState.Occasion ? (React.createElement(SituationSelectOptionsGroups_1.SituationSelectOptionsGroups, { optionsGroups: situationOptions.occasionOptions, selected: selected, onSelect: onSelect })) : (React.createElement(React.Fragment, null));
    return ReactDOM.createPortal(React.createElement(Window, null,
        React.createElement(SituationSelectHeader_1.SituationSelectHeader, { title: props.state === ModalState.Presentee
                ? titleOf.presentee
                : props.state === ModalState.Age
                    ? titleOf.age
                    : props.state === ModalState.Occasion
                        ? titleOf.occasion
                        : titleOf.presentee, cancel: cancel }),
        React.createElement(SituationSelectNavigator_1.SituationSelectNavigator, { state: props.state, selectedPresentee: props.selectedPresentee, selectedAge: props.selectedAge, selectedOccasion: props.selectedOccasion, onClickPresentee: toPresenteeState, onClickAge: toAgeState, onClickOccasion: toOccasionState }),
        React.createElement(SituationSelectDescriptor_1.SituationSelectDescriptor, { state: props.state }),
        React.createElement(Options, { inTransition: false }, optionElements),
        React.createElement(SituationSelectFooter_1.SituationSelectFooter, { selected: selected, back: props.state > ModalState.Presentee ? back : null, skip: skip })), modalRoot);
};
var Window = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: fixed;\n  z-index: 200;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: #eee;\n"], ["\n  position: fixed;\n  z-index: 200;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: #eee;\n"])));
var Options = styled_components_1["default"].div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  opacity: ", ";\n  transition: all 60ms 0s linear;\n"], ["\n  opacity: ", ";\n  transition: all 60ms 0s linear;\n"])), function (props) { return (props.inTransition ? "0" : "1"); });
var OptionsContentLoading = styled_components_1["default"].div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: absolute;\n  overflow: auto;\n  width: 100%;\n  top: 100px;\n  bottom: 60px;\n  background-color: #eee;\n"], ["\n  position: absolute;\n  overflow: auto;\n  width: 100%;\n  top: 100px;\n  bottom: 60px;\n  background-color: #eee;\n"])));
var templateObject_1, templateObject_2, templateObject_3;
